import React from 'react';
import { UserHoverCardContent } from '@components/Feed/User/UserHoverCardContent';
import { Avatar } from '@components/basics/Images/Avatar';
import { UserAvatar } from '@components/icons/UserAvatar';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { UserHoverCard } from '@components/main-components/user/UserHoverCard';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, InvitedUserByFragmentDoc } from '@graphql/reactQuery';
import { NAV_LINKS } from '@utils/constants';
import { webappUriPath } from '@utils/url';

export const InvitedBy = ({
  user,
  showSelectUser,
}: {
  showSelectUser?: boolean;
  user: FragmentType<InvitedUserByFragmentDoc> | null;
}) => {
  if (showSelectUser) {
    return (
      <div className="flex">
        <AccessibleLink
          pathnameUri={webappUriPath(NAV_LINKS.ProfileEdit)}
          className="flex items-center justify-center gap-[6px]"
        >
          <UserAvatar className="mr-[2px] w-5 text-base400 md:mx-[1px]" />
          <div className="text-base-m font-medium leading-6 text-base400">
            Invited by <span className="text-black underline">select user</span>
          </div>
        </AccessibleLink>
      </div>
    );
  }

  const userInfo = getFragment(InvitedUserByFragmentDoc, user);

  if (!userInfo) return null;

  const { avatar, publicAddress, username, webappUri, id: userId } = userInfo;

  const userWebappUri = webappUriPath(webappUri);
  const hoverCardTrigger = (
    <AccessibleLink pathnameUri={userWebappUri} className="flex items-center gap-[6px]">
      <Avatar
        size={22}
        src={avatar?.url}
        walletAddress={publicAddress}
        disableLink
        borderRadius="50%"
        webappUri={userWebappUri}
      />
      <div className="truncate text-base-m font-medium leading-6 text-base400">
        Invited by <span className="text-black">{username}</span>
      </div>
    </AccessibleLink>
  );

  return (
    <div className="flex">
      <UserHoverCard
        userHoverCardContent={<UserHoverCardContent userId={userId} />}
        trigger={hoverCardTrigger}
      />
    </div>
  );
};
